const reveal = (img) => img.classList.add('is-loaded');

// Cached images won't fire load — check immediately
for (const img of document.querySelectorAll('img[loading="lazy"]')) {
  if (img.complete) reveal(img);
}

// Capturing listeners handle both current and future injected images
// (load/error don't bubble, so capturing is required)
const onSettle = (e) => {
  if (e.target.matches('img[loading="lazy"]')) reveal(e.target);
};

document.addEventListener('load', onSettle, true);
document.addEventListener('error', onSettle, true);
